module.exports = __webpack_public_path__ + "img/fleet-hub-logo.2b34f225.svg";